export const company = {
  name: 'Rinkal Enterprise & Healthcare Services',
  legalName: 'Rinkal Enterprises and Healthcare Private Limited',
  formerName: 'Formerly known as Samridhi Healthcare Facilities',
  tagline: 'Your Trusted Partner in Health, Care & Technology',
  motto: 'Connecting Health, Care & Technology - One Service at a Time.',
  founded: '2016',
  rebranded: '2024',
  phone: '+91 87003 70255',
  website: 'www.samridhihealthcarefacilities.com',
  address: 'Hospital Road, Saini Market, Rajoria Nagar, Sohna, Haryana - 122103',
  about:
    'Founded in 2016 by healthcare and management experts, Rinkal Enterprise & Healthcare Services began as Samridhi Healthcare Facilities and was rebranded in 2024 to reflect a broader vision across healthcare and enterprise support.',
  vision:
    'To become a leading name in integrated healthcare and service excellence, connecting people, technology, and medical care through ethical, reliable, and affordable solutions.',
  mission: [
    'Deliver timely and professional healthcare services.',
    'Strengthen diagnostic, preventive, and emergency networks.',
    'Empower healthcare professionals through technology and digital marketing.',
    'Build long-term partnerships based on trust, transparency, and quality.',
  ],
};

export const profileServices = [
  {
    id: 'blood-collection',
    name: 'Blood Collection Centre',
    service_type: 'pathology',
    description:
      'Trained phlebotomy team, NABL-standard sample handling, doorstep collection, and safe medical sample logistics.',
  },
  {
    id: 'wellness-camps',
    name: 'Preventive Health Checkups & Wellness Camps',
    service_type: 'health_tech',
    description:
      'Corporate and institutional health programs with doctor consultation, preventive screening, and on-site health camps.',
  },
  {
    id: 'ambulance',
    name: 'Ambulance & Emergency Response Services',
    service_type: 'ambulance',
    description:
      '24/7 BLS and ALS-equipped ambulance support for emergency care, planned transfers, and inter-hospital movement.',
  },
  {
    id: 'healthcare-logistics',
    name: 'Courier & Healthcare Logistics',
    service_type: 'courier',
    description:
      'Secure, temperature-controlled medical logistics with optimized delivery workflows and real-time tracking.',
  },
  {
    id: 'digital-health-tech',
    name: 'Digital Marketing & Health-Tech Solutions',
    service_type: 'it',
    description:
      'SEO, hospital CRM, patient engagement, social media branding, AI automation tools, and healthcare technology support.',
  },
  {
    id: 'hospital-management',
    name: 'Hospital Administration & Management',
    service_type: 'management',
    description:
      'Operational, HR, performance, and administration support for hospitals and healthcare institutions.',
  },
  {
    id: 'medical-tourism',
    name: 'Medical Tourism',
    service_type: 'tourism',
    description:
      'End-to-end assistance for domestic and international patients seeking quality treatment and coordinated care.',
  },
  {
    id: 'tpa-empanelment',
    name: 'TPA & Government Empanelment',
    service_type: 'tpa',
    description:
      'Hospital empanelment liaison, cashless service onboarding, policy coordination, and government scheme support.',
  },
];

export const whyChooseUs = [
  'One-stop integrated healthcare service provider',
  'Trusted legacy since 2016',
  'Tech-enabled transparency and tracking',
  'Professional, trained, and ethical team',
  'Affordable, efficient, and people-centric approach',
];

export const leadership = [
  'Mrs. Rinkal Kumari - Founder',
  'Mr. Manoj Upadhyay - MD, Co-founder, CEO & CFO',
  'Mr. Gangesh Tripathi - COO & CTO (Director)',
  'Mr. Manas Kumar - Legal Advisor',
  'Mr. Tarunendra Shekhar Singh - Advisor',
];

export const partnerNetwork = {
  hospitals: [
    {
      name: 'Shivam Hospital',
      logo: '/partners/shivam-hospital.svg',
    },
    {
      name: 'SilverStreak Hospital',
      logo: '/partners/silverstreak-hospital.svg',
    },
    {
      name: 'Sarvodya Hospital',
      logo: '/partners/sarvodya-hospital.svg',
    },
    {
      name: 'Swastik Seva Kendra',
      logo: '/partners/swastik-seva-kendra.svg',
    },
    {
      name: 'Family Healthcare Hospital',
      logo: '/partners/family-healthcare-hospital.svg',
    },
  ],
  corporate: [
    {
      name: 'Coforge',
      logo: '/partners/coforge.svg',
    },
    {
      name: 'Incuzaspace',
      logo: '/partners/incuzaspace.svg',
    },
    {
      name: 'Gabriel Limited',
      logo: '/partners/gabriel-limited.svg',
    },
    {
      name: 'Quantum Builder Enterprises',
      logo: '/partners/quantum-builder-enterprises.svg',
    },
    {
      name: 'M3M Project',
      logo: '/partners/m3m-project.svg',
    },
  ],
};

export const futureGoals = [
  'Expansion of diagnostic and ambulance networks',
  'Launch of AI-based digital CRM and patient systems',
  'Multi-location blood collection centers',
  'Subscription-based family and corporate health plans',
];

export const clientTestimonials = [
  {
    id: 'patient-doorstep-collection',
    name: 'Anita Sharma',
    title: 'Patient',
    rating: 5,
    message:
      'The blood collection team reached on time, handled the sample carefully, and kept us updated throughout the process. It felt professional and reassuring.',
  },
  {
    id: 'hospital-logistics',
    name: 'Operations Manager',
    title: 'Partner Hospital',
    rating: 5,
    message:
      'Rinkal Healthcare has been dependable for sample movement and coordination. Their team is responsive, disciplined, and easy to work with.',
  },
  {
    id: 'corporate-camp',
    name: 'HR Team',
    title: 'Corporate Wellness Client',
    rating: 5,
    message:
      'The wellness camp was organized smoothly for our employees. Registration, basic screening, and doctor consultation were all managed neatly.',
  },
  {
    id: 'ambulance-support',
    name: 'Rajesh Kumar',
    title: 'Patient Family Member',
    rating: 5,
    message:
      'During an urgent transfer, the ambulance coordination was quick and calm. The team guided us clearly and helped reduce a stressful situation.',
  },
  {
    id: 'tpa-support',
    name: 'Administration Desk',
    title: 'Healthcare Partner',
    rating: 4,
    message:
      'Their support with TPA and empanelment documentation helped us move faster. The communication was transparent and practical.',
  },
  {
    id: 'digital-health-tech',
    name: 'Clinic Director',
    title: 'Health-Tech Client',
    rating: 5,
    message:
      'The digital marketing and patient engagement guidance helped us present our services better and respond to enquiries more efficiently.',
  },
];
